import Success from 'components/alerts/Success'
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { InviteUsers } from 'components/graphql/queries';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import * as JSCookie from 'js-cookie';
import React from 'react';
import { fetchGraphQL } from 'services/graphql/GraphQL';

export default class InviteUsersModal extends React.Component<{ [label: string]: any }, { [label: string]: any }> {
    constructor(props) {
        super(props)
        this.state = {
            emails: '',
            success: false
        }
        this.handleAddUsers = this.handleAddUsers.bind(this);
        this.handleTeamNewUserChange = this.handleTeamNewUserChange.bind(this);
    }

    public handleTeamNewUserChange(e: any) {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    public handleAddUsers(newData: any) {
        this.setState(
            (oldState: any) => {
                return {
                    isLoading: true
                };
            },
            () => {
                const trimmedEmails = this.state.emails.toLowerCase().split("\n").map(item => {
                    return item.trim()
                });
                fetchGraphQL(InviteUsers(), JSCookie.get("token"), {
                    emails: trimmedEmails,
                }).then(result => {
                    // console.log(result)
                    this.setState({
                        success: true
                    })
                });
            }
        );
    }

    public render() {
        return <div>
            {
                !this.state.success ?
                    <div>
                        <TextArea
                            label={"E-mails"}
                            name="emails"
                            value={this.state.emails}
                            onChange={this.handleTeamNewUserChange}
                            infoMessage={
                                "One e-mail per line. For Facebook or Google please input their registration e-mail."
                            }
                        />
                        <p />
                        <br />
                        <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <button
                                className='new-button-white-3'
                                style={{
                                    border: 'none'
                                }}
                                onClick={e => closeModal()}
                            >
                                CANCEL
                            </button>
                            <button
                                className='new-button-white-3'
                                style={{
                                    border: 'none'
                                }}
                                onClick={this.handleAddUsers}
                            >
                                INVITE
                        </button>
                        </div>
                    </div>
                    : <div>
                        <p />
                        <Success content="Invitation links sent!" />
                        <p />
                        <br />
                        <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <button
                                className='new-button-white-3'
                                style={{
                                    border: 'none'
                                }}
                                onClick={e => closeModal()}
                            >
                                DONE
                            </button>
                        </div>
                    </div>
            }
        </div>
    }
}   


// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/InviteUsersModal.tsx